import { logger } from './helpers/logger.ts'
import { openMimetypesMarkdown, openMimetypesPlainText } from './helpers/mime.js'

/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import 'vite/modulepreload-polyfill'

/**
 * Wrapper for async registration of ViewerComponent.
 * Note: it should be named function - the name is used for component registration.
 *
 * @return {Promise<import('./views/ViewerView.js')>} ViewerComponent
 */
function AsyncTextViewerComponent() {
	return import('./views/ViewerView.js')
}

if (typeof OCA.Viewer === 'undefined') {
	logger.error('Viewer app is not installed')
} else {
	OCA.Viewer.registerHandler({
		id: 'text',
		mimes: [...openMimetypesMarkdown, ...openMimetypesPlainText],
		component: AsyncTextViewerComponent,
		group: null,
		theme: 'default',
		canCompare: true,
		downloadCallback: async (fileInfo) => {
			// Save any unsaved changes before download
			const editors = window.OCA?.Text?.editorComponents
			if (editors instanceof Set) {
				for (const editor of editors) {
					if (editor?.fileId === fileInfo.fileid && editor?.dirty) {
						logger.debug('Saving file before download', {
							fileId: fileInfo.fileid,
						})
						await editor.save()
						return
					}
				}
			}
		},
	})
}
